<template>
  <div>
    <div>
      <div class="ad">
        <a-carousel autoplay>
          <div v-for="item in adverts1" :key="item.id" style="height:100%">
            <img :src="base_url + item.images" alt />
          </div>
        </a-carousel>
      </div>
    </div>
    <div class="tabs">
      <a-tabs
        size="large"
        :tabBarStyle="{ border: 'none' }"
        default-active-key="1"
      >
        <a-tab-pane key="1">
          <span slot="tab" style="font-size:20px">
            <icon-font type="icon-shuxian" />热门医院
          </span>
          <tabDemo></tabDemo>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab" style="font-size:20px">热门科室</span>
          <tabDivision></tabDivision>
        </a-tab-pane>

        <a-tab-pane key="3">
          <span slot="tab" style="font-size:20px">热门医生</span>
          <tabDoctor></tabDoctor>
        </a-tab-pane>

        <a-tab-pane key="4">
          <span slot="tab" style="font-size:20px">疾病</span>
          <tabIllness></tabIllness>
        </a-tab-pane>
      </a-tabs>
    </div>

    <pcContent></pcContent>
  </div>
</template>

<script>
import { setToken } from '@/utils/auth'
import { getRandomAesKey, ls, decrypt } from '@/utils/tool'
import { getInfo } from '@/api/user'
import tabDemo from './index/components/tabDemo'
import tabDivision from './index/components/tabDivision'
import tabDoctor from './index/components/tabDoctor'
import tabIllness from './index/components/tabIllness'
import pcContent from './index/components/content'
import { getAdverts } from '@/api/index'
import { message } from 'ant-design-vue'
import qs from 'qs'
import { webWxLogin, webZfbLogin } from '@/api/threelogin.js'
import { base_url } from '@/utils/request'

export default {
  name: 'index',
  components: {
    tabDemo,
    tabDivision,
    tabDoctor,
    tabIllness,
    pcContent
  },
  data() {
    return {
      advertForm: {
        pageNum: 1,
        pageSize: 4
      },
      adverts1: [], //头部广告
      token: ls.get('token')
    }
  },
  created() {
    console.log(this.$route)
    if (this.$route.params.info) {
      this.$message.warn('请重新登录')
    }
  },
  mounted() {
    this.initAdverts1()
  },
  methods: {
    async initAdverts1() {
      var res = await getAdverts({ ...this.advertForm, position: 1 })
      if (res.code == 200) {
        this.adverts1 = res.data.list
        return
      }
      this.adverts1 = []
      this.$message.error(res.message)
    },

    onSearch(value) {
      if (!value) {
        message.warning('请先输入搜索内容！')
        return
      }
      this.$router.push({
        path: '/search-result',
        query: {
          keyWord: value
        }
      })
    }
  },
  async beforeRouteEnter(to, from, next) {
    let url = window.location.href
    if (url.indexOf('?') != -1) {
      if (url.indexOf('?') > url.indexOf('#')) {
        let query = qs.parse(url.substring(url.indexOf('?') + 1))
        if (!query.auth_code) {
          next()
          return
        }
        let res = await webZfbLogin({ authCode: query.auth_code })
        if (res.code == 40001) {
          next({
            name: 'login_dev',
            params: { authCode: query.auth_code, registerType: 2 }
          })
          return
        }
        if (res.code == 200) {
          setToken(res.data)
          ls.set('token', res.data)
          let key = getRandomAesKey()
          let resUser = await getInfo({ token: res.data, key })
          if (resUser) {
            let obj = JSON.parse(
              decrypt(resUser.data, key.slice(0, 16), key.slice(16))
            )
            ls.set('sysUser', obj)
            window.open(base_url, '_self')
            // next({ name: "index" });
            return
          }
        } else {
          next({ name: 'login', params: { message: res.message } })
        }
        // console.log("支付宝返回的参数");
      } else {
        let query = qs.parse(
          url.substring(url.indexOf('?') + 1, url.indexOf('#'))
        )
        if (!query.code) {
          next()
          return
        }
        let res = await webWxLogin(query)
        console.log('微信登录接口参数', res)
        if (res.code == 40001) {
          next({
            name: 'login_dev',
            params: { authCode: query.code, registerType: 1 }
          })
          return
        } else if (res.code == 200) {
          setToken(res.data)
          ls.set('token', res.data)
          let key = getRandomAesKey()
          let resUser = await getInfo({ token: res.data, key })
          if (resUser) {
            let obj = JSON.parse(
              decrypt(resUser.data, key.slice(0, 16), key.slice(16))
            )
            console.log('user====', obj)
            ls.set('sysUser', obj)
            window.open(base_url, '_self')
            // next({ name: "index" });
            return
          }
        } else {
          next({ name: 'login', params: { message: res.message } })
        }
        // console.log("微信返回的参数");
      }
    } else {
      next()
    }
  }
}
</script>
<style scoped lang="less">
.ad {
  /* For demo */

  .ant-carousel /deep/ .slick-slide {
    width: 100%;
    text-align: center;
    height: 430px;
    overflow: hidden;

    div {
      height: 100%;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .ant-carousel /deep/ .slick-slide h3 {
    color: #fff;
  }

  /deep/ .ant-carousel .slick-dots-bottom {
    bottom: 24px;
  }

  .ant-carousel /deep/ .slick-dots li button {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #c8c8c8;
  }

  /deep/ .slick-active button {
    width: 16px !important;
    height: 16px !important;
    border-radius: 50%;
  }

  /deep/ .ant-carousel .slick-dots li.slick-active button {
    background: #4169ad;
  }
}

.search {
  position: absolute;
  bottom: -35px;
  z-index: 99;
  margin: 0 auto;
  width: 1010px;
  height: 70px;
  background: #ffffff;
  border-radius: 10px;

  /deep/ .ant-input {
    padding-left: 60px !important;
    font-size: 20px;
  }

  /deep/ .ant-input-search-button {
    width: 141px;
    font-size: 20px;
  }

  /deep/ .ant-input,
  /deep/ .ant-input-search-button {
    height: 70px;
  }

  /deep/ svg {
    width: 30px;
    height: 30px;
    margin-left: 50;
    margin-right: 18px;
  }

  /*修改提示文字的颜色*/

  /deep/ input::-webkit-input-placeholder {
    /* WebKit browsers */
    font-size: 20px;
  }

  /deep/ input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */

    font-size: 20px;
  }

  /deep/ input::-moz-placeholder {
    /* Mozilla Firefox 19+ */

    font-size: 20px;
  }

  /deep/ input:-ms-input-placeholder {
    /* Internet Explorer 10+ */

    font-size: 20px;
  }
}

.tabs {
  padding-top: 18px;
  width: 1200px;
  margin: 0 auto;

  .ant-tabs-nav .ant-tabs-tab .anticon {
    margin-right: -2px;
    font-weight: bold;
  }

  .ant-tabs {
    color: #999999;

    /deep/ .ant-tabs-ink-bar {
      height: 0;
    }
  }

  .child {
    display: flex;
    position: relative;
    align-items: center;

    .page {
      position: absolute;
      z-index: 999;
    }

    .up {
      left: -25px;
    }

    .next {
      right: -25px;
    }
  }
}

.partners {
  padding-top: 69px;
  width: 1200px;
  margin: 0 auto;

  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 1;
    margin-bottom: 39px;
  }

  .partner {
    width: 100%;

    img {
      width: 197px;
      height: 100px;
      margin-bottom: 40px;
    }
  }
}
</style>
